import digitalData from 'digital-data';
import {
  PIP_SUB_CONTENT,
  INTERACTION
} from '../constants';

export const stickyNav = () => {

  window.LIFE_CYCLE_EVENT_BUS.on('@@STICKY-NAV/CLICK', (payload) => {
    if (window.isDebugMode) {
      console.log('%c @@STICKY-NAV/CLICK is deprecated.', 'background: red; color: black', payload);
    }
  });

  window.LIFE_CYCLE_EVENT_BUS.on('sticky-nav.click', ({ output }) => {
    const { target = '' } = output;
    const ddoEvent = {
      eventInfo: {
        eventName: PIP_SUB_CONTENT
      },
      category: {
        primaryCategory: INTERACTION
      },
      subContent: {
        section: 'sticky-nav',
        component: 'nav-menu-item',
        target
      }
    };
    (digitalData?.event || []).push(ddoEvent);
  });
};
